var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-select-theme"},[_c('div',{staticClass:"l-select-theme__inner"},_vm._l((_vm.availableTypes),function(type){return _c('div',{key:type,staticClass:"o-primary-btn l-select-theme__item c-select-theme__item",on:{"click":function($event){return _vm.setType(type)}}},[_vm._v(" "+_vm._s(_vm.getType(type))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }